import { createAction } from '@reduxjs/toolkit';
import { AdminSettingsFormData } from 'src/components/pages/Settings/AdminSettings/AdminSettings';
import { ChangePasswordFormData } from 'src/components/ui/ChangePasswordModal/ChangePasswordModal';

import { GlobalFile } from '../models/Action';
import {
  CheckUser,
  LoginRequest,
  SupportInfo,
  SyncUser,
  Theme,
  User,
} from '../models/Auth';
import { WhiteLabelConfig } from '../models/WhiteLabel';

export const AUTH_SLICE = 'auth';

export const checkUser = createAction<{ email: string }>(
  `${AUTH_SLICE}/checkUser`
);
export const login = createAction<LoginRequest>(`${AUTH_SLICE}/login`);
export const loginSuccess = createAction<User>(`${AUTH_SLICE}/loginSuccess`);
export const setLoginSuccess = createAction<boolean>(
  `${AUTH_SLICE}/setLoginStep`
);
export const setAuthCheck = createAction<CheckUser[]>(
  `${AUTH_SLICE}/setAuthCheck`
);
export const syncUser = createAction(`${AUTH_SLICE}/syncUser`);
export const logout = createAction(`${AUTH_SLICE}/logout`);

/* Change password */
export const changePassword = createAction<ChangePasswordFormData>(
  `${AUTH_SLICE}/changePassword`
);

/* Change settings */
export const changeSettings = createAction<{
  image: GlobalFile;
  settingsData?: AdminSettingsFormData;
  dynamicSettings?: WhiteLabelConfig[];
}>(`${AUTH_SLICE}/changeSettings`);

/* Set all users */
export const setAllUsers = createAction<SyncUser[]>(
  `${AUTH_SLICE}/setAllUsers`
);

/* Switch manufacturer */
export const switchManufacturer = createAction<{ manId: string }>(
  `${AUTH_SLICE}/switchManufacturer`
);

/* Get support info */
export const getSupportInfo = createAction(`${AUTH_SLICE}/getSupportInfo`);
export const setSupportInfo = createAction<SupportInfo>(
  `${AUTH_SLICE}/setSupportInfo`
);

/* Edit support info */
export const editSupportInfo = createAction<SupportInfo>(
  `${AUTH_SLICE}/editSupportInfo`
);

/* Send new password */
export const sendNewPassword = createAction<{ userId: string; title: string }>(
  `${AUTH_SLICE}/sendNewPassword`
);

/* Change theme */
export const changeTheme = createAction<Theme>(`${AUTH_SLICE}/changeTheme`);
